<app-header></app-header>
<app-loader />
<div class="main-content mt-3">
  @if (token) {
    <router-outlet />
  } @else {
    <app-unauthorized />
  }
</div>
